<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">分级评分栏目管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="栏目名称">
          <el-input v-model="formInline.category" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="分数">
          <el-select v-model="formInline.score" clearable placeholder="请选择" style="width:216px;">
            <el-option v-for="item in scoreOptions" :key="item" :label="`${item}分`" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增评分栏目</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="category" label="栏目名称" min-width="300">
        </custom-table-column>
        <custom-table-column prop="score" label="分数" width="120">
        </custom-table-column>
        <custom-table-column prop="order" label="排序" width="120">
        </custom-table-column>
        <custom-table-column prop="source" label="来源" width="100">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="140">
          <template slot-scope="scope" v-if="scope.row.source == '学校新增'">
            <el-button @click="handleEditNew(scope.row, ['id'])" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="600px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="栏目名称" prop="category">
          <el-input type="textarea" v-model="ruleForm.category" :rows="3" placeholder="请输入栏目名称"
            style="width:412px;"></el-input>
        </el-form-item>
        <el-form-item label="分数" prop="score">
          <el-select v-model="ruleForm.score" placeholder="请选择" style="width:216px;">
            <el-option v-for="item in scoreOptions" :key="item" :label="`${item}分`" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="order">
          <el-input v-model="ruleForm.order" placeholder="请输入排序" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';

export default {
  name: 'ratingCategorySet',
  mixins: [mixinList, mixinValidate],
  data() {
    return {
      formInline: {
        category: '',
        score: '',
      },
      // 分数选项
      scoreOptions: [5, 10, 25],
      ruleForm: {
        category: '',
        score: '',
        order: 10,
      },
      rules: {
        category: [{ required: true, message: '请输入栏目名称', trigger: 'blur' }],
        score: [{ required: true, message: '请选择分数', trigger: 'change' }],
        order: [{ required: true, message: '请输入排序', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
      },
    };
  },
  created() { },
  methods: {
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    // 列表:api/rating/category/list
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/rating/category/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data || [];
        this.total = res.data.total || 0;
      }
    },
    // 新增:api/rating/category/store
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/rating/category/store', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    // 编辑:api/rating/category/update/{id}
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/rating/category/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    // 删除:api/rating/category/destroy/{id}
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/rating/category/destroy/${this.delid}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
